import set from 'lodash/set'
import keys from 'lodash/keys'
import has from 'lodash/has'
import get from 'lodash/get'
import isArray from 'lodash/get'
import isFunction from 'lodash/isFunction'
import mergeWith from 'lodash/mergeWith'

// deprecated?
// function updateObject(obj, toUpdate, value) {
//     if (typeof toUpdate === 'string') {
//         const path = toUpdate
//         set(obj, path, value)
//     } else {
//         Object.entries(toUpdate).forEach(([path, value]) => {
//             set(obj, path, value)
//         })
//     }
// }

export function createDataManager(loadedData, storeData) {
    const _onUpdateListeners = []
    const data = loadedData
    return {
        getData: () => data,
        onUpdateDone: (listener) => _onUpdateListeners.push(listener),
        updateData: async (dataToUpdate, deprecated_value) => {
            if (typeof dataToUpdate === 'string') {
                const deprecated_pathToField = dataToUpdate
                set(data, deprecated_pathToField, deprecated_value)
            } else {
                Object.entries(dataToUpdate).forEach(([path, value]) => {
                    set(data, path, value)
                })
            }
            _onUpdateListeners.forEach(listener => listener(data))
            if (storeData) {
                await storeData(data)
            }
        }
    }
}

function isRepeater(compState) {
    return !!compState.$item
}

const SHOULD_EXPAND = '#shouldExpand'

function renderShouldExpand(itemState, itemCompId, itemData, $item) {
    const shouldExpandFunc = itemState[SHOULD_EXPAND]
    if (shouldExpandFunc(itemData)) {
        $item(itemCompId).expand()
    } else {
        $item(itemCompId).collapse()
    }
}

const SHOULD_SHOW = '#shouldShow'

function renderShouldShow(itemState, itemCompId, itemData, $item) {
    const shouldShowFunc = itemState[SHOULD_SHOW]
    if (shouldShowFunc(itemData)) {
        $item(itemCompId).show()
    } else {
        $item(itemCompId).hide()
    }
}

function render(uiState) {
    keys(uiState).forEach(compId => {
        const compState = uiState[compId]
        renderPaths(compState.paths, compId)
        if (isRepeater(compState)) {
            renderRepeater(compState, compId)
        }
        renderExpandability(compState, compId)
        renderVisibility(compState, compId)
    })
}

function renderRepeater(compState, compId) {
    $w(compId).forEachItem(($item, itemData) => {
        keys(compState.$item).forEach(itemCompId => {
            renderRepeatedItem(compState.$item[itemCompId], $item, itemData, itemCompId)
        })
    })

    // if (!compState.itemReadyHookSet) {
    //     $w(compId).onItemReady(($item, itemData) => {
    //             keys(compState.$item).forEach(itemCompId => {
    //                 renderRepeatedItem(compState.$item[itemCompId], $item, itemData, itemCompId)
    //             })
    //         }
    //     )

    //     compState.itemReadyHookSet = true
    // }
}

function renderPaths(paths, compId) {
    const component = $w(compId)
    keys(paths).forEach(pathToField => {
        if (has(component, pathToField)) {
            const value = paths[pathToField]
            set(component, pathToField, value)
        } else {
            console.warn(`renderPaths: Could not set "${pathToField}" for component with ID "${compId}"`)
        }
    })
}

function renderExpandability(compState, compId) {
    if (Object.prototype.hasOwnProperty.call(compState, SHOULD_EXPAND)) {
        // if (compState.hasOwnProperty(SHOULD_EXPAND)) {
        const component = $w(compId)
        if (component.expand) {
            (compState[SHOULD_EXPAND]) ? component.expand(): component.collapse()
        } else {
            console.warn(`renderExpandability: Could not expand/collapse component with ID "${compId}"`)
        }
    }
}

function renderVisibility(compState, compId) {
    if (Object.prototype.hasOwnProperty.call(compState, SHOULD_SHOW)) {
        // if (compState.hasOwnProperty(SHOULD_SHOW)) {
        const component = $w(compId)
        if (component.hide) {
            (compState[SHOULD_SHOW]) ? component.show(): component.hide()
        } else {
            console.warn(`renderVisibility: Could not show/hide component with ID "${compId}"`)
        }
    }
}

const supportedEvents = ['onClick', 'onMouseIn', 'onMouseOut']

function renderRepeatedItem(repeatedItemState, $item, itemData, itemCompId) {
    const element = $item(itemCompId)

    if (isFunction(repeatedItemState)) {
        supportedEvents.forEach(eventName => {
            const eventNameOnce = `${eventName}Once`
            const eventWasSet = `${eventName}WasSet`
            element[eventNameOnce] = (callback) => {
                if (!element[eventWasSet]) {
                    element[eventName](callback)
                    element[eventWasSet] = true
                }
            }
        })

        repeatedItemState(element, itemData, $item)
    } else {
        keys(repeatedItemState).forEach(componentPathToField => {
            if (componentPathToField === SHOULD_EXPAND) {
                renderShouldExpand(repeatedItemState, itemCompId, itemData, $item)
            } else if (componentPathToField === SHOULD_SHOW) {
                renderShouldShow(repeatedItemState, itemCompId, itemData, $item)
            } else {
                const itemDataValuePath = repeatedItemState[componentPathToField]
                const value = get(itemData, itemDataValuePath)
                if (value) {
                    if (has(element, componentPathToField)) {
                        set(element, componentPathToField, value)
                    } else {
                        console.warn(`renderRepeatedItem: Could not set "${componentPathToField}" for component with ID "${itemCompId}"`)
                    }
                }
            }
        })
    }
}

function handleArrays(objValue, srcValue) {
    if (isArray(objValue)) return srcValue
}

export function createUIStateManager(dataManager, mapData2State) {
    let _uiState = mapData2State(dataManager.getData())

    dataManager.onUpdateDone((updatedData) => {
        let newStateFromData = mapData2State(updatedData)
        let newState = mergeWith(_uiState, newStateFromData, handleArrays)
        render(newState)
    })

    return {
        getState: () => _uiState,
        updateData: (dataToUpdate, deprecated_value) => {
            if (typeof dataToUpdate === 'string') {
                const deprecated_pathToField = dataToUpdate
                set(_uiState, deprecated_pathToField, deprecated_value)
            } else {
                Object.entries(dataToUpdate).forEach(([path, value]) => {
                    set(_uiState, path, value)
                })
            }
            render(_uiState)
        },
        start: () => {
            render(_uiState)
        }
    }
}

/**
 eventHandles: {
		<compId>: {
			<event>: <handler>
		}
	}

 Example
 eventHandles: {
		‘#button1’: {
			‘onClick’: <handler>
		}
	}
 */
export function hookEvents(pageApp, eventHandles) {
    keys(eventHandles).forEach(compId => {
        const compEvents = eventHandles[compId]
        keys(compEvents).forEach(eventName => {
            if (typeof $w(compId)[eventName] === 'function') {
                $w(compId)[eventName]((...args) => {
                    compEvents[eventName](pageApp, args)
                })
            } else {
                console.warn(`hookEvents: Could not hook event "${eventName}" for component with ID "${compId}"`)
            }
        })
    })
}